var render = function render(){var _vm=this,_c=_vm._self._c;return _c('canvas',{attrs:{"width":"400","height":"250"}})
}
var staticRenderFns = []

export { render, staticRenderFns }